//import { css } from "@emotion/react"

import clone from "clone";
import { useNavigate } from "react-router-dom";
import type { ImmutableObject } from "@/lib/immutable";
import { useCheckoutFormState } from "../../../hooks/useCheckoutFormState";
import type { Product } from "../../../hooks/useInventoryState";
import { useProductDetailsState } from "../../../hooks/useProductDetailsState";
import { Button } from "../../ui/button";

export type ProductBrowserGridItemDescriptionProps = {
	product: ImmutableObject<Product>;
};
export const ProductBrowserGridItemDescription: React.FC<
	ProductBrowserGridItemDescriptionProps
> = (props) => {
	const product = props.product;
	const productDetailsState = useProductDetailsState();
	const checkoutFormState = useCheckoutFormState();
	const warehouseId = checkoutFormState.get().warehouseIdValue;
	const locationId = checkoutFormState.get().locationIdValue;
	const fromDate = checkoutFormState.get().fromDateValue;
	const toDate = checkoutFormState.get().toDateValue;
	const navigate = useNavigate();

	return (
		<Button
			variant="link"
			className="field itemdescription whitespace-normal underline-offset-1 flex-1 flex items-start"
			onClick={async () => {
				return Promise.resolve().then(async () => {
					await productDetailsState.setProductAsync(clone(product) as Product);
					navigate(
						`/product/${product.Id}/warehouseid/${warehouseId}/locationid/${locationId}/fromdate/${fromDate}/todate/${toDate}`,
					);
					//productDetailsState.setShowPopup(true);
				});
			}}
		>
			{product.ItemName}
		</Button>
	);
};
